import {
    assertInArray,
    assertMaximum,
    assertMinimum,
    assertStringOrNumber
} from '../../validators';
import type {
    CommonAttributeSettings, CommonMetadataKeys,
    PropDescriptor
} from './common';
import {
    createPropertyDescription,
    DEFAULT_ATTRIBUTE_SETTINGS
} from './common';


type StringOrNumberAttributeSettings = CommonAttributeSettings & {
     choices: string[];
     min: number;
     max: number;
};
export const INFERRED_NUMBER_ATTRIBUTE_TYPE = 'StringOrNumberAttributeType';
export type StringOrNumberMetadataKeys = keyof StringOrNumberAttributeSettings | CommonMetadataKeys;
const DEFAULT_SETTINGS: StringOrNumberAttributeSettings = {
    ...DEFAULT_ATTRIBUTE_SETTINGS,
    choices: [],
    min: -Infinity,
    max: Infinity,
};

/**
 * Creates an attribute decorator used to describe a string property. In addition to the shared
 * attribute settings, the string decorator allows validation to enforce the value is a member of inArray.
 * @param settings
 */
export function StringOrNumberAttribute(settings: Partial<StringOrNumberAttributeSettings> = {}) {
    settings = { ...DEFAULT_SETTINGS, ...settings };
    return function(target: object, propertyKey: string, descriptor: PropDescriptor) {
        const validator = (value: number|string) => {
            assertStringOrNumber(value);

            if (typeof value === 'string') {
                if (settings.choices.length > 0) {
                    assertInArray(value, settings.choices);
                }
            }
            else {
                assertMinimum(value, settings.min);
                assertMaximum(value, settings.max);
            }
        };
        return createPropertyDescription(target, propertyKey, descriptor, settings, validator, INFERRED_NUMBER_ATTRIBUTE_TYPE);
    } as any;
}
